import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NLog } from '../../models/nlog.model';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { NlogService } from '../../services/nlog.service';

@Component({
    selector: 'app-nlog',
    template: require('./nlog.component.html'),
    styles: [require('./nlog.component.scss')]
})
export class NlogComponent implements OnInit, OnDestroy {
    options: any;
    nLogs: NLog[] = [];
    selectedNlogs: NLog[] = [];
    loading: boolean;
    private subscribers: Subscription[] = [];
    constructor(private nlogService: NlogService, private alretService: AlertService) { }

    ngOnInit() {
        this.getNlogs();
    }

    ngOnDestroy(): void {
        if (this.subscribers) {
            this.subscribers.forEach(k => k.unsubscribe());
        }
    }

    private getNlogs() {
        this.loading = true;
        const getSub = this.nlogService.getAllNlogs().subscribe((res: NLog[]) => {
            if (res != null) {
                this.nLogs = res;
            }
            this.loading = false;
        }, error => {
            this.loading = false;
            console.error('error occured while Loading data');
        });
        this.subscribers.push(getSub);
    }

    deleteNlogByIds() {
        if (this.nLogs.length > 0) {
            this.alretService.startLoadingMessage('Deleting Records', 'NLog');
            let ids: string = "0";
            if (this.selectedNlogs && this.selectedNlogs.length > 0) {
                ids = this.selectedNlogs.map(z => z.Id).toString();
            } else {
                ids = this.nLogs.map(z => z.Id).toString();
            }
            this.loading = true;
            const delSub = this.nlogService.deleteNlogById(ids).subscribe((res) => {
                this.alretService.stopLoadingMessage();
                this.alretService.showMessage('NLog', 'Records Deleted', MessageSeverity.success);
                this.getNlogs();
            }, error => {
                this.loading = false;
                console.error('error occured while Deleting data');
            });

            this.subscribers.push(delSub);
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/nlog/nlog.component.ts